
























import * as announcementBoardService from '@/store/Services/announcementBoardService';
import {Component,Prop,Vue,Watch} from 'vue-property-decorator';
import * as $ from 'jquery';
import store from '@/store';
import {FoldersTreeNodeData} from '@/components/Cartable/FoldersTree/FoldersTreeNode/FoldersTreeNode.vue';
import FoldersTreeNodePlain from '@/components/Cartable/FoldersTree/FoldersTreeNode/FoldersTreeNodePlain.vue';
import { AnnouncementBoard } from '@/store/models/AnnouncementBoard/AnnouncementBoard';
@Component({
     components:{FoldersTreeNodePlain}
})
export default class AnnoncementBoardSelector extends Vue{
    selectedBoard = {name: "", id:""};
    @Prop() defaultBoardId?: string;
    
    

    async created(){
        
        const ownerId =  store.state.ownerId;
        const announcementBoards = await announcementBoardService.getAccessibleAnnouncementBoards(ownerId);
        const announcementBoardsNode = {} as FoldersTreeNodeData;
        announcementBoardsNode.name = 'برد اعلانات و اسناد';
        announcementBoardsNode.isRoot = true;
        announcementBoardsNode.url = 'AnnouncementBoards';
        // announcementBoardsNode.iconClass = {'icon-AnnouncementBoard':true,'fixed-icon':true }
        announcementBoardsNode.children = [];
        this.addAnnouncementBoard(announcementBoardsNode,announcementBoards);
        this.folders.push(announcementBoardsNode);
        store.state.eventHub.$on('board-selected',this.onBoardSelected);
        
        if(this.defaultBoardId)
        {
            this.getBoardNameRecursive(this.defaultBoardId,announcementBoards);
           
            this.selectedBoard.id = this.defaultBoardId;
            this.selectedBoard.name = this.findedName;
        }
    }
     onFocus(){
        //this.searchTxt = '';
        //if(this.validValues)
            //this.filteredValues = this.validValues;
        $(".dropdown").dropdown({action:'hide',onShow:this.onDropdownShow,onHide: this.onDropdownHide});
    }
    onBoardSelected(eventArg: any){
        this.$emit('board-selected',eventArg);
        this.selectedBoard = eventArg;
    }
    onDropdownShow(){
        return true;
    }
    onDropdownHide(){
        return true;
    }
   
    mounted(){
        $(".dropdown").dropdown({action:'nothing',onShow:this.onDropdownShow,onHide: this.onDropdownHide});
    }

    addAnnouncementBoard(parent: FoldersTreeNodeData, announcementBoards: AnnouncementBoard[]){
        announcementBoards.forEach(board=>{
            const childNode = {} as FoldersTreeNodeData;
            childNode.name = board.name;
            childNode.isRoot = false;
            childNode.id = board.id;
            // childNode.iconClass = {'icon-AnnouncementBoardChild':true,'fixed-icon':true};
            // childNode.url = `AnnouncementBoard?boardId=${board.id}`;
            childNode.isSelected = false;
            childNode.children = [];
            parent.children.push(childNode);
            if(board.children !== null && board.children != undefined)
                this.addAnnouncementBoard(childNode,board.children);
        });
    }
    findedName = '';
    getBoardNameRecursive(id: string, boards: AnnouncementBoard[]){
        boards.forEach(board=>{
            if(board.id == id)
                this.findedName =  board.name;
            else
                if(board.children){
                    this.getBoardNameRecursive(id,board.children);
                    
                }
                
        });
        
    }
    folders: FoldersTreeNodeData[] = [];
}
